import React, { useEffect, useRef } from 'react';
import { useField } from '@unform/core';

import Input, { InputProps } from '../Input';

type UnformInputProps = InputProps & {
  name: string;
};

const UnformInput: React.FC<UnformInputProps> = ({ name, ...rest }) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const { fieldName, defaultValue, error, registerField } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  return (
    <Input ref={inputRef} defaultValue={defaultValue} error={error} {...rest} />
  );
};

export default UnformInput;
